module.exports = __webpack_public_path__ + "static/stars-279e312b70c2b94fdef1be9546407ef3.png";